import { render, staticRenderFns } from "./NewsViewDetail.vue?vue&type=template&id=2fb94924&scoped=true&"
import script from "./NewsViewDetail.vue?vue&type=script&lang=js&"
export * from "./NewsViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsViewDetail.vue?vue&type=style&index=0&id=2fb94924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb94924",
  null
  
)

export default component.exports